import { render, staticRenderFns } from "./CrmPieChart.vue?vue&type=template&id=aac8e430&"
import script from "./CrmPieChart.vue?vue&type=script&lang=js&"
export * from "./CrmPieChart.vue?vue&type=script&lang=js&"
import style0 from "./CrmPieChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports